import * as React from 'react';

import { MenuItem } from 'components/bootstrap';
import EntityCollectionModal from 'collections/components/EntityCollectionModal';
import type View from 'views/logic/views/View';

type Props = {
  modalRef: () => any;
};

export const DashboardCollectionsModal = React.forwardRef(
  ({ dashboard }: { dashboard: View }, ref: (r: any) => void) => (
    <EntityCollectionModal
      entityId={dashboard.id}
      entityType="dashboard"
      ref={ref}
      title={`Manage Collection for ${dashboard.title}`}
    />
  ),
);

export const SearchManageCollectionsModal = React.forwardRef(({ search }: { search: View }, ref: (r: any) => void) => (
  <EntityCollectionModal
    entityId={search.id}
    entityType="search"
    ref={ref}
    title={`Manage Collection for ${search.title}`}
  />
));

export const ShareCollectionsModal = React.forwardRef(
  (
    // eslint-disable-next-line react/require-default-props
    { entity, entityType, onClose = undefined }: { entity: any; entityType: string; onClose?: () => void },
    ref: (r: any) => void,
  ) => (
    <EntityCollectionModal
      entityId={entity.id}
      entityType={entityType}
      ref={ref}
      onClose={onClose}
      title={`Manage Collection for ${entity.title}`}
    />
  ),
);

const EntityCollectionActions = ({ modalRef }: Props) => (
  <MenuItem onClick={() => modalRef()?.toggle()}>Manage collections</MenuItem>
);

type SearchActionProps = {
  loaded: boolean;
  search: View;
  modalRefs: { [key: string]: () => any };
};

export const SearchEntityCollectionActions = ({ loaded, search: _, modalRefs }: SearchActionProps) => {
  const { searchManageCollectionModal } = modalRefs;

  return loaded ? <EntityCollectionActions modalRef={() => searchManageCollectionModal()?.toggle()} /> : null;
};

export default EntityCollectionActions;
